<template>
    <app-main>
        <app-content>

            <div class="flex flex-wrap -mx-2">
                <div class="w-full md:w-1/2 px-2">
                    <!-- Start Title -->
                    <app-title
                        title="Menus"
                        sub-title="Editing a menu"
                    />
                    <!-- End Title -->
                </div>
                <div class="w-full md:w-1/2 px-2 md:text-right">
                     <app-button element="a" class="btn  btn--primary  btn--primary--sml" @click="save">
                        Save
                    </app-button>

                    <app-button element="a" class="btn  btn--secondary  btn--secondary--sml ml-4" @click="$router.push({ name: 'menus.home' })">
                        Cancel
                    </app-button>
                </div>
            </div>

            <app-box v-if="loading" :loading="loading" />
            <app-menu-manager
                v-else
                :menu="fields.data"
                @save="updateMenu"
            />
        </app-content>
    </app-main>
</template>

<script>
    /* API */
    import Api from '@/api/index.js';
    import Auth from '@/api/auth.js';
    /* Components */
    import Main from '@/components/Main';
    import Content from '@/components/template/Content';
    import Title from '@/components/Title';
    import Box from '@/components/Box';
    import Button from '@/components/Button';
    import MenuManager from '@/components/MenuManager';

    /* Mixins */
    import ValidationErrors from '@/mixins/validationErrors.js';

    export default {
        name: 'menus.edit',

        data: () => ({
            menu: null,
            fields: {
                data: []
            },
            loading: false,
            errors: {}
        }),

        components: {
            'app-main': Main,
            'app-content': Content,
            'app-title': Title,
            'app-box': Box,
            'app-button': Button,
            'app-menu-manager': MenuManager
        },

        mixins: [
            ValidationErrors
        ],

        mounted() {
            if (typeof this.$route.params.id != 'undefined') {
                this.loading = true;

                this.getMenu(this.$route.params.id)
                    .then(response => {
                        this.loading = false;

                        this.fields.data = this.menu.data;
                    })
                    .catch(error => {
                        this.$router.push({name: 'menus.home'});
                    });
            } else {
                this.$router.push({name: 'menus.home'});
            }
        },

        methods: {
            getMenu(id) {
                return Api.request('get', `menus/edit/${id}`)
                    .then(({ data }) => {
                        this.menu = data.menu;
                    });
            },
            updateMenu(value) {
                this.fields.data = value;
            },
            save() {
                this.loading = true;
                this.clearErrors();

                return Api.request('post', `menus/update/${this.menu.id}`, this.fields).then(response => {
                    if(typeof response.data.message != 'undefined') {
                        this.$toasted.show(response.data.message, { 
                            type: "success", 
                            position: "bottom-right", 
                            duration : 5000
                        });
                    }
                    if(typeof response.data.id != 'undefined') {
                        this.$router.push({
                            name: 'menus.home'
                        });
                    }
                }).catch(error => {
                    if(this.hasErrors(error)) {
                        this.addErrors(error);
                    }
                }).then(response => {
                    this.loading = false;
                });
            },
        },
    }
</script>



// WEBPACK FOOTER //
// src/views/menus/Edit.vue